import { Placement } from "./Placement";
import {
  BODY_SKINS,
  DIRECTION_DOWN,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
} from "../helpers/consts";
import { TILES } from "../helpers/tiles";
import Sprite from "../components/object-graphics/Sprite";

const conveyorDirectionMap = new Map();
conveyorDirectionMap.set(DIRECTION_DOWN, TILES.CONVEYOR_DOWN);
conveyorDirectionMap.set(DIRECTION_UP, TILES.CONVEYOR_UP);
conveyorDirectionMap.set(DIRECTION_RIGHT, TILES.CONVEYOR_RIGHT);
conveyorDirectionMap.set(DIRECTION_LEFT, TILES.CONVEYOR_LEFT);

const STAND_STILL_ON_CONVEYOR_BEFORE_MOVE = 8;

export class ConveyorTilePlacement extends Placement {
  constructor(properties, level) {
    super(properties, level);
    this.direction = properties.direction;
  }

  givesPreAutoMoveFrames(forBody) {
    if (forBody.isImmuneToConveyor) {
      return 0;
    }
    return STAND_STILL_ON_CONVEYOR_BEFORE_MOVE;
  }

  changeHeroSkinOnCollide() {
    return BODY_SKINS.CONVEYOR;
  }

  renderComponent() {
    return <Sprite frameCoord={conveyorDirectionMap.get(this.direction)} />;
  }
}
